import FAQ from "components/Blocks/FAQ"

const faqContent = {
  sections: [
    {
      title: null,
      faqs: [
        {
          question: "What can I do with the Preset API?",
          answer:
            "The Preset API lets you manage workspaces, user access, and BI assets programmatically. Data teams use it to automate permission management, sync assets across environments, and treat Superset configuration as code.",
        },
        {
          question: "Is the Preset API based on Apache Superset's API?",
          answer:
            "Yes. The Preset API extends Superset's native REST API with additional endpoints for managing Preset-specific resources like workspaces and organizations. Existing Superset API clients work with Preset with minimal changes.",
        },
        {
          question: "How do I authenticate with the Preset API?",
          answer:
            "The Preset API uses JWT-based authentication. You generate an API key from your Preset account settings, then exchange it for a short-lived token to include in your API requests.",
        },
        {
          question: "Can I manage users and workspaces via the API?",
          answer:
            "Yes. The API supports full user lifecycle management: inviting users, assigning roles, and managing workspace membership. You can also create and configure workspaces programmatically.",
        },
        {
          question: "Can I manage charts and dashboards as code?",
          answer:
            "Yes. The Preset API lets you import and export charts, dashboards, and datasets as YAML or JSON. This enables asset versioning, CI/CD workflows, and multi-environment deployments from a single source of truth.",
        },
        {
          question: "Does the API support multi-workspace management?",
          answer:
            "Yes. The Preset API operates at the organization level, letting you manage multiple workspaces from a single API client. This is useful for teams that maintain separate development, staging, and production environments.",
        },
      ],
    },
  ],
}

function FAQSection() {
  return (
    <FAQ
      label="Common Questions"
      heading="Frequently Asked Questions"
      content={faqContent}
    />
  )
}

export default FAQSection
